import React from 'react';
import {
  Modal,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  Well,
  Pager,
} from 'react-bootstrap';

import DropDownMenu from '../../../commonComponents/DropDownMenu';
import DiscussionCell from '../workLog/DiscussionCell';


const PagerInstance = props => {
  return (
    <Pager className="reportModalPager">
        <Pager.Item onClick={props.onClickPrevious}>上一則</Pager.Item>
        {' '}
        <Pager.Item onClick={props.onClickNext} >下一則</Pager.Item>
    </Pager>
  );
}

export default class ReportWorkLogViewModalPs extends React.Component {
    render(){
        let {
            onClickCloseModal,
            selectedRow,
            onClickNext,
            onClickPrevious,
            selectedRowIndex,
            searchResultLength
        } = this.props;

        // for 產品多選顯示
        const selectionArr = [],
              optsProduct = selectedRow.model_name.map((item, ind) => {
                    selectionArr.push(ind);
                    return {
                        value: ind,
                        label: item
                    };
              });
        
        return(
            <Modal bsSize="large" show={true} className="reportModal">
                <Modal.Header>
                    <Modal.Title>
                        <span className="modeText">
                            <span style={{float: "left"}}>
                                <span style={{color: "rgba(0, 0, 200, .7"}}>檢視</span>
                            </span>
                        </span>
                        <div className="modal-page">
                            <PagerInstance 
                                onClickNext={onClickNext}
                                onClickPrevious={onClickPrevious} />
                            <span className="pageText">{`${selectedRowIndex + 1} / ${searchResultLength} 頁`} </span>
                        </div>
                        <Button 
                            className="btnClose"
                            onClick={onClickCloseModal}
                            style={{float: 'right', marginLeft: 5, position: "relative", zIndex: "3"}}>關閉</Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                        <FormGroup controlId="creator">
                            <ControlLabel style={{marginBottom: 0}}>
                                {/* {languageData['9'][languageCode]} */}
                                建立者
                                {" "}
                                <span style={{fontWeight: 'normal', marginBottom: 0}}>
                                    {selectedRow.workOwnerName || this.props.userName}
                                </span>
                                <DiscussionCell
                                    rowIndex={this.props.selectedRowIndex}
                                    columnKey="worklog_discuss_count"
                                    sortedData={this.props.workLogSortedData}
                                    onClick={this.props.onDiscussionsClick}
                                    style={{textAlign: 'center'}}
                                    className="worklog-discussion-cell inside-worklog-modal" />
                            </ControlLabel>
                        </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                        <div style={{fontWeight: "bold"}}>客戶</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Well>
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup controlId="company">
                                            <ControlLabel>公司</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value={selectedRow.company_name}
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup controlId="contact">
                                            <ControlLabel>聯絡人</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value={selectedRow.contact_name}
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup controlId="department">
                                            <ControlLabel>部門</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value={selectedRow.department_name}
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup controlId="email">
                                            <ControlLabel>email</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value={selectedRow.email}
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup controlId="mobile">
                                            <ControlLabel>手機</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value="手機"
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup controlId="tel">
                                            <ControlLabel>室話</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value="tel"
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Well>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup controlId="workNature">
                                <ControlLabel>工作性質</ControlLabel>
                                <FormControl
                                    readOnly={true}
                                    tabIndex={-1}
                                    type='text'
                                    value={selectedRow.nature_name}
                                    style={{height: 36}} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <div style={{fontWeight: "bold"}}>拜訪日期</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Well>
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <ControlLabel>起</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value={selectedRow.visit_start_date}
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <ControlLabel>迄</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value={selectedRow.visit_end_date}
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Well>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup controlId="description">
                                <ControlLabel>內容</ControlLabel>
                                <FormControl 
                                    readOnly={true}
                                    value={selectedRow.content}
                                    componentClass="textarea"
                                    style={{height: 200}} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <DropDownMenu
                            multi={true}
                            sm={12}
                            disabled={true}
                            label="產品"
                            value={selectionArr}
                            // stateName="arrRelatedProducts"
                            // onChange={}
                            options={optsProduct} />

                        {/*<Col sm={12}>
                            <FormGroup>
                                <ControlLabel>產品</ControlLabel>
                                <FormControl
                                    readOnly={true}
                                    tabIndex={-1}
                                    type='text'
                                    value="產品"
                                    style={{height: 36}} />
                            </FormGroup>
                        </Col>*/}
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <ControlLabel>Progress Status</ControlLabel>
                                <FormControl
                                    readOnly={true}
                                    tabIndex={-1}
                                    type='text'
                                    value={selectedRow.progress_name}
                                    style={{height: 36}} />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <ControlLabel>Project Progress</ControlLabel>
                                <FormControl
                                    readOnly={true}
                                    tabIndex={-1}
                                    type='text'
                                    value={selectedRow.project_progress_name}
                                    style={{height: 36}} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <div style={{fontWeight: "bold"}}>下次拜訪日期</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Well>
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <ControlLabel>起</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value={selectedRow.next_start_date}
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <ControlLabel>迄</ControlLabel>
                                            <FormControl
                                                readOnly={true}
                                                tabIndex={-1}
                                                type='text'
                                                value={selectedRow.next_end_date}
                                                style={{height: 36}} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Well>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/report/ReportWorkLogViewModalPs.jsx